import React, { memo } from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-stone-950 text-stone-400 py-12 border-t border-stone-800" data-id="element-59">
      <div className="container mx-auto px-4" data-id="element-60">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-61">
          <div className="text-center md:text-left" data-id="element-62">
        
            <h3 className="text-2xl font-bold text-stone-100 font-serif mb-2" data-id="element-63">
              Mangalita Events
            </h3>
            <p className="text-sm" data-id="element-64">Creating memories in Kitwe since 2024.</p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium" data-id="element-65">
            <Link to="/" className="hover:text-rose-400 transition-colors" data-id="element-66">
              Home
            </Link>
            <Link to="/weddings" className="hover:text-rose-400 transition-colors" data-id="element-67">
              Weddings
            </Link>
            <Link to="/birthdays" className="hover:text-rose-400 transition-colors" data-id="element-68">
              Birthdays
            </Link>
            <Link to="/special-events" className="hover:text-rose-400 transition-colors" data-id="element-69">
              Special Events
            </Link>
            <Link to="/contact" className="hover:text-rose-400 transition-colors" data-id="element-70">
              Contact
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-stone-800 text-center text-xs text-stone-500" data-id="element-71">
          <p data-id="element-72">
            &copy; {new Date().getFullYear()} Mangalita Events. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}